// extracted by mini-css-extract-plugin
module.exports = {"list":"SectionNestedPages-module--list--3lryU","item":"SectionNestedPages-module--item--3fijX"};